// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"818":"2cf7b967","856":"41d6d4ee"}[chunkId] + ".chunk.css";
};